"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var questions = [{
  prompt: "Don’t worry if guilt isn’t the right word for your feeling. You might just feel bad in some way. Look for what you feel responsible for in general that isn’t working out how you want it to.",
  type: "textAreaWithMore",
  meta: {
    answerLabel: "What is your responsibility thought?",
    summaryTitle: "My responsibility thought was…"
  },
  moreInfoLabel: "Can you give me some examples?",
  moreInfo: ["Here are some examples:", "The break up from my partner was my fault.", "Or.. The reason things aren’t working out well is my fault."],
  batteryId: "GUILT"
}, _defineProperty({
  prompt: "Consider whether your parents, your friends, your colleagues, other influential people played a role. Would things be different if these people never existed? Who else might have influenced the outcome?",
  batteryId: "GUILT",
  type: "multiWithOther",
  meta: {
    answerLabel: "Who else?",
    summaryTitle: "However, other people influenced the outcome including.."
  },
  options: ["My parents", "Someone else’s parents", "Colleagues", "Friends", "Teachers, managers or supervisors", "Partners", "Family", "Other"]
}, "batteryId", "GUILT"), {
  prompt: "How much influence did they have as a rough percentage? How much of it was influenced by them? In other words, if they had nothing to do with it what are the chances it would have turned out differently?",
  type: "percentageSlider",
  meta: {
    summaryTitle: "Other people's percentage of influence"
  },
  batteryId: "GUILT"
}, {
  prompt: "Consider whether your education, alcohol, stress, illness, money, environment or culture played a role. Would things be different if these factors never existed? So what else might have influenced the outcome?",
  type: "multiWithOther",
  meta: {
    answerLabel: "what influenced outcome?",
    summaryTitle: "And other factors influenced the outcome including..."
  },
  options: ["My education", "Alcohol or substances", "Stress or illness", "Money", "My environment", "My culture", "Other"],
  batteryId: "GUILT"
}, {
  prompt: "How much influence did these factors have as a rough percentage? In other words, if these factors had nothing to do with it what are the chances it would have turned out differently?",
  type: "percentageSlider",
  meta: {
    summaryTitle: "Other factors percentage of influence"
  },
  moreInfoLabel: "Can you give me some examples?",
  batteryId: "GUILT"
}, {
  prompt: "So the amount of responsibility left after you remove everyone else’s roles is…",
  type: "multiRadio",
  meta: {
    summaryTitle: "Amount of responsibility left"
  },
  options: ["My role in it was very small (about 0 - 20%)", "My role in it was small (about 20 - 30%)", "My role in it was moderate (about 30 - 60%)", "My role in it was large (about 60 - 100%)"],
  batteryId: "GUILT"
}, {
  prompt: "It’s normal to make mistakes. The goal isn’t to stop making mistakes as that’s impossible. The goal is to get good at repairing mistakes with others. Is there anything that you can do to repair this situation so that you can move on?",
  type: "multiWithOther",
  meta: {
    answerLabel: "what can be done?",
    summaryTitle: "Action to take"
  },
  options: ["Apologise to the other person", "Do something good for the other person", "Do something positive for a stranger that balances out the negative act", "Other"],
  batteryId: "GUILT"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;